<template>
  <v-dialog v-model="showModal" width="500" persistent class="z5">
    <v-card>
      <v-card-title class="text-h5 white--text third">
        <span class="d-flex justify-left flex-grow-1">Cheval déjà affecté</span>
        <v-icon size="28" color="white" class="justify-end" @click="closeModal">mdi-close</v-icon>
      </v-card-title>

      <v-card-text class="mt-4 d-flex flex-column">
        <span class="text-subtitle-1">
          Ce cheval est déjà prévu sur une autre reprise/session à cette heure.
          Voulez-vous poursuivre et effectuer le changement ?
        </span>
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn outlined rounded class="ma-2 third--text" color="white" :disabled="loading" @click="closeModal">
          Non
        </v-btn>
        <v-btn outlined rounded class="ma-2 third--text" color="white" :loading="loading" @click="handleConfirm">
          Oui
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import store from '@/store';

export default {
  setup () {
    const loading = ref(false);
    const showModal = computed(() => store.state.swapHorseModal.show);

    const closeModal = () => {
      store.commit('setSwapHorseModal', { show: false, callback: null });
    };

    const handleConfirm = async () => {
      const callback = store.state.swapHorseModal.callback;
      if (callback) {
        loading.value = true;
        await callback();
        loading.value = false;
      }
      closeModal();
    };

    return {
      showModal,
      closeModal,
      handleConfirm,
      loading
    };
  }
};
</script>